import React, { useState } from "react";
import BookList from "./bookList";
import * as api from "../lib/api";
import BookFilters from "./bookFilters";
import BooksBySeries from "./booksBySeries";
import { filterByKey } from "../lib/filters";
import { NOTEXISTS } from "../lib/constants";

const Books = ({
  title,
  tag,
  items,
  bySeries,
  genre,
  hideFilters = false,
  topContent,
  bottomContent,
}) => {
  const [activeFilters, setActiveFilters] = useState({
    series: undefined,
    category: undefined,
  });

  const onFilterUpdate = (filters) => {
    setActiveFilters(filters);
  };

  let filteredItems = api.getBooksByGenre(genre, items);
  if (activeFilters.series)
    filteredItems = api.getBooksBySeries(activeFilters.series, filteredItems);
  if (activeFilters.category)
    filteredItems = api.getBooksByCategory(
      activeFilters.category,
      filteredItems
    );

  let series = [];
  let nonSeries = [];
  if (bySeries) {
    series = api.sortByPubDate(api.getSeriesByGenre(genre));
    nonSeries = filterByKey(
      "seriesNum",
      NOTEXISTS,
      api.getBooksByGenre(genre, items)
    );
  }

  return (
    <div className="section">
      <div className="heading" id={tag}>
        <h3>{title}</h3>
      </div>
      <div className="content">
        {!!topContent && <>{topContent}</>}
        {!hideFilters && (
          <BookFilters genre={genre} onFilterUpdate={onFilterUpdate} />
        )}
        {bySeries ? (
          <>
            {series.map((s) => (
              <BooksBySeries seriesId={s.id} items={items} />
            ))}
            {nonSeries ? (
              <div className="section">
                <div className="subheading" id={"other-fiction-books"}>
                  <h5>{"Other Fiction Books"}</h5>
                </div>
                <div className="content">
                  <BookList items={nonSeries ?? []} />
                </div>
              </div>
            ) : undefined}
          </>
        ) : (
          <BookList items={filteredItems} />
        )}
        {!!bottomContent && <>{bottomContent}</>}
      </div>
    </div>
  );
};

export default Books;
